module.exports = __webpack_public_path__ + "static/media/bja-logo.b1f0f262.svg";